import { useHttp } from '@/shared/lib'
import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция загрузки списка
 */
export const useLoadInventMapTypes = (objectId: Ref<string>) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_invent_map_types', objectId],
    queryFn: async () => {
      const response = await http.get(`/inventory/objects/${objectId.value}/object-types/full`)
      return response.data
    },
    retry: false,
  })
}
